/**
 * The partner code of a referral link (partner program), `?p=CODE`.
 *
 * The site (callizy.ca) keeps it in a `callizy_partenaire` cookie on
 * `.callizy.ca` for 90 days; the server reads that cookie when it creates the
 * company. A link that leads straight to the app (`/fr/signup?p=CODE`, sent
 * here by the site's middleware) is kept the same way. The first code wins.
 * Step 2 of the sign-up shows it in the "Partner code" field.
 * Same rules as the server (programme_partenaires/models.py).
 * When the cookie is first set, the visit is counted for the partner's space.
 */
import { API_BASE_URL } from '@/lib/config'

const NOM = 'callizy_partenaire'
const DUREE = 90 * 24 * 3600

/** A letter first, then letters and digits: `?p=2` (a page) is not a code. */
export function normaliser(v: string | null | undefined): string {
  const code = (v || '').slice(0, 100).replace(/[\s-]/g, '').toUpperCase()
  return /^[A-Z][A-Z0-9]{3,19}$/.test(code) ? code : ''
}

function domaine(): string {
  const h = window.location.hostname
  return h === 'callizy.ca' || h.endsWith('.callizy.ca') ? '; domain=.callizy.ca' : ''
}

export function lire(): string {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${NOM}=([^;]*)`))
    return normaliser(m ? decodeURIComponent(m[1]) : '')
  } catch {
    return ''
  }
}

/** On the sign-up and sign-in pages only: elsewhere `?p=` may mean something else. */
export function capturer(): void {
  if (!/^\/(fr|en)\/(signup|login)(\/|$)/.test(window.location.pathname)) return
  const code = normaliser(new URLSearchParams(window.location.search).get('p'))
  if (!code || lire()) return
  const secure = window.location.protocol === 'https:' ? '; secure' : ''
  try {
    document.cookie = `${NOM}=${code}; path=/; max-age=${DUREE}; samesite=lax${secure}${domaine()}`
  } catch {
    /* cookies blocked: the code can still be typed at step 2 */
  }
  if (lire() !== code) return
  try {
    void fetch(`${API_BASE_URL}/api/partenaires/clic/?p=${encodeURIComponent(code)}`, {
      method: 'POST', mode: 'no-cors', keepalive: true,
    }).catch(() => undefined)
  } catch {
    /* a lost count is not worth an error */
  }
}
